<app-header></app-header>

<div class="middle-content-wrap">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <h5>Dynamic Popups</h5>
          <button class="btn btn-primary float-right" (click)="openCreateModal()">
            <i class="fas fa-plus"></i> Create Popup
          </button>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <div class="row mb-3">
              <div class="col-md-2" *ngIf="false">
                <!-- Hiding simplistic page size for now if not fully wired or to match style -->
                <select class="form-control" (change)="onLimitChange($event)">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>

            <table class="table table-hover">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Image</th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>External Link</th>
                  <th>Target Group</th>
                  <th>Active</th>
                  <th>Repeat Frequency</th>
                  <th>Created At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let popup of dynamicPopups">
                  <td>{{ popup.id }}</td>
                  <td>
                    <img [src]="popup.image" alt="Popup Image"
                      style="width: 50px; height: 50px; object-fit: cover; border-radius: 4px;">
                  </td>
                  <td>{{ popup.title }}</td>
                  <td title="{{ popup.description }}">
                    {{ popup.description ? (popup.description | slice:0:30) + (popup.description.length > 30 ? '...' :
                    '') : '-' }}
                  </td>
                  <td>
                    <a *ngIf="popup.external_link" [href]="popup.external_link" target="_blank"
                      title="{{ popup.external_link }}">Link</a>
                    <span *ngIf="!popup.external_link">-</span>
                  </td>
                  <td>
                    <span class="badge badge-primary">{{ popup.target_group || 'ALL' }}</span>
                  </td>
                  <td>
                    <span class="badge" [ngClass]="popup.active ? 'badge-success' : 'badge-danger'">
                      {{ popup.active ? 'Active' : 'Inactive' }}
                    </span>
                  </td>
                  <td>{{ popup.repeat_frequency }} Days</td>
                  <td>{{ popup.createdAt | date:'mediumDate' }}</td>
                  <td>
                    <button class="btn btn-sm btn-info mr-1" (click)="openViewModal(popup)">
                      <i class="fas fa-eye"></i>
                    </button>
                    <button class="btn btn-sm btn-warning mr-1" (click)="openEditModal(popup)">
                      <i class="fas fa-edit"></i>
                    </button>
                    <button class="btn btn-sm btn-danger" (click)="openDeleteModal(popup)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="dynamicPopups.length === 0 && !isLoading">
                  <td colspan="10" class="text-center">No popups found</td>
                </tr>
                <tr *ngIf="isLoading">
                  <td colspan="10" class="text-center">Loading...</td>
                </tr>
              </tbody>
            </table>

            <!-- Pagination to be implemented based on project standard, simplistic version here -->
            <div class="row" *ngIf="total > 0">
              <div class="col-md-6">
                Showing {{ (page - 1) * limit + 1 }} to {{ page * limit > total ? total : page * limit }} of {{ total }}
                entries
              </div>
              <div class="col-md-6 text-right">
                <button class="btn btn-sm btn-secondary mr-1" [disabled]="page === 1"
                  (click)="onPageChange(page - 1)">Previous</button>
                <button class="btn btn-sm btn-secondary" [disabled]="page * limit >= total"
                  (click)="onPageChange(page + 1)">Next</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Create/Edit Modal -->
<div class="modal fade" id="createEditModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ isEditMode ? 'Edit Popup' : 'Create Popup' }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="popupForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label>Title <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="title"
              [ngClass]="{ 'is-invalid': submitted && f['title'].errors }">
            <div *ngIf="submitted && f['title'].errors" class="invalid-feedback">
              <div *ngIf="f['title'].errors['required']">Title is required</div>
            </div>
          </div>

          <div class="form-group">
            <label>Description</label>
            <textarea class="form-control" formControlName="description" rows="3"
              [ngClass]="{ 'is-invalid': (submitted || f['description'].touched) && f['description'].errors }"></textarea>
            <div class="d-flex justify-content-between mt-1">
              <small class="form-text text-muted">
                Max {{ maxDescriptionLength }} characters allowed {{ maxDescriptionLength === 300 ? '(with image)' :
                '(without image)' }}.
              </small>
              <small class="text-muted">
                {{ f['description'].value?.length || 0 }} / {{ maxDescriptionLength }}
              </small>
            </div>
            <div *ngIf="(submitted || f['description'].touched) && f['description'].errors"
              class="invalid-feedback d-block">
              <div *ngIf="f['description'].errors['maxlength']">
                Description cannot exceed {{ maxDescriptionLength }} characters.
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>External Link</label>
            <input type="url" class="form-control" formControlName="external_link" placeholder="https://example.com">
          </div>

          <div class="form-group">
            <label>Target Group <span class="text-danger">*</span></label>
            <select class="form-control" formControlName="target_group"
              [ngClass]="{ 'is-invalid': submitted && f['target_group'].errors }">
              <option *ngFor="let group of targetGroups" [value]="group">{{ group }}</option>
            </select>
            <div *ngIf="submitted && f['target_group'].errors" class="invalid-feedback">
              <div *ngIf="f['target_group'].errors['required']">Target Group is required</div>
            </div>
          </div>

          <div class="form-group">
            <label>Status</label>
            <select class="form-control" formControlName="active">
              <option [ngValue]="true">Active</option>
              <option [ngValue]="false">Inactive</option>
            </select>
            <small class="form-text text-muted">If active, it will go live immediately once created.</small>
          </div>

          <div class="form-group">
            <label>Repeat Frequency (in days) <span class="text-danger">*</span></label>
            <input type="number" class="form-control" formControlName="repeat_frequency" min="0">
            <small class="form-text text-muted">
              0 means it will be only shown once, 1 means it will be shown daily, 7 means weekly, etc.
            </small>
            <div *ngIf="submitted && f['repeat_frequency'].errors" class="invalid-feedback d-block">
              <div *ngIf="f['repeat_frequency'].errors['required']">Repeat Frequency is required</div>
            </div>
          </div>

          <div class="form-group">
            <label>Image (Optional)</label>

            <div *ngIf="isEditMode && selectedPopup?.image && !removeImage" class="mb-2 d-flex align-items-center">
              <img [src]="selectedPopup!.image" alt="Current Popup Image" class="img-thumbnail mr-2"
                style="max-height: 100px;">
              <button type="button" class="btn btn-danger btn-sm" (click)="removeExistingImage()">
                <i class="fas fa-times"></i> Remove Image
              </button>
            </div>
            <div *ngIf="removeImage" class="alert alert-warning p-1 mb-2">
              Values image will be removed upon saving.
            </div>

            <input type="file" class="form-control-file" (change)="onFileChange($event)" accept="image/*">
            <small *ngIf="isEditMode" class="form-text text-muted">Leave empty to keep existing image</small>
          </div>

          <div class="modal-footer px-0 pb-0">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary" [disabled]="isLoading">
              {{ isLoading ? 'Saving...' : 'Save Changes' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- View Modal -->
<div class="modal fade" id="viewModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Popup Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="selectedPopup">
        <div class="text-center mb-3">
          <img [src]="selectedPopup.image" alt="Popup Image" class="img-fluid rounded" style="max-height: 200px;">
        </div>
        <p><strong>ID:</strong> {{ selectedPopup.id }}</p>
        <p><strong>Title:</strong> {{ selectedPopup.title }}</p>
        <p><strong>Description:</strong> {{ selectedPopup.description || 'N/A' }}</p>
        <p><strong>External Link:</strong>
          <a *ngIf="selectedPopup.external_link" [href]="selectedPopup.external_link" target="_blank">{{
            selectedPopup.external_link }}</a>
          <span *ngIf="!selectedPopup.external_link">N/A</span>
        </p>
        <p><strong>Target Group:</strong> {{ selectedPopup.target_group || 'ALL' }}</p>
        <p><strong>Status:</strong> {{ selectedPopup.active ? 'Active' : 'Inactive' }}</p>
        <p><strong>Repeat Frequency:</strong> {{ selectedPopup.repeat_frequency }} Days</p>
        <p><strong>Created At:</strong> {{ selectedPopup.createdAt | date:'medium' }}</p>
        <p><strong>Updated At:</strong> {{ selectedPopup.updatedAt | date:'medium' }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Confirm Delete</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to delete this popup?</p>
        <p *ngIf="selectedPopup"><strong>{{ selectedPopup.title }}</strong></p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="confirmDelete()" [disabled]="isLoading">
          {{ isLoading ? 'Deleting...' : 'Delete' }}
        </button>
      </div>
    </div>
  </div>
</div>